export var getCookie = function (name) {
    var value = document.cookie;
    var parts = value.split("".concat(name, "="));
    if (parts.length === 2)
        return parts.pop().split(";").shift();
};
